let Dialog = require("./Dialog");
let CloseButton = require("./CloseButton");

class Modal extends Dialog {
  onFocus(evt) {
    let items = this._getTabItems();
    let index = [].indexOf.call(items, evt.target);

    if (index > -1) {
      // anti-pattern! to avoid recursion on focus()
      this.state.index = index;
    }
  }

  render() {
    let {
      width,
      height,
      minWidth,
      maxWidth,
      dismissable,
      label,
      labeledBy,
      verticalAlign,
      children
    } = this.props;

    let button = null;

    if (dismissable) {
      let top = `calc((100% - ${height}) / 2)`;

      button = (
        <div className="mc-modal-close mc-screen" style={{ top, width, minWidth, maxWidth }}>
          <CloseButton color="#333333" size={20} onClick={this.close.bind(this)} tabIndex="0"/>
        </div>
      );
    }

    return (
      <div className="mc-modal-scrim" tabIndex="0">
        <div
          className="mc-modal-dialog"
          style={{ width, height, minWidth, maxWidth }}
          ref="dialog"
          role="dialog"
          aria-label={label}
          aria-labelledby={labeledBy}
          tabIndex="-1">
            <div className="mc-modal-body" data-align={verticalAlign} onFocus={this.onFocus.bind(this)}>
              {children}
            </div>
        </div>
        {button}
      </div>
    );
  }
}

Modal.defaultProps = {
  dismissable: true,
  verticalAlign: "top",
  width: "75%",
  height: "75%",
  minWidth: "400px",
  maxWidth: "800px",
  label: null,
  labeledBy: null,
  selector: "a, button, input, select, textarea, [tabindex='0']",
  _filters: ".mc-drop-reveal"
};

module.exports = Modal;